module.exports = __webpack_public_path__ + "img/blue.600d138f.svg";